module.exports = true;



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4078178155/src/~/core-js/library/modules/_library.js
// module id = 5D9A
// module chunks = 6